<template>
    <flex-element :element-type="elementType" tag="div">
        <input
            :id="recaptchaId"
            name="g-recaptcha-response"
            type="hidden"
            :value="tokenValue"
        >

        <div ref="scriptContainer" />
    </flex-element>
</template>

<script>
import { mapState } from 'vuex';
import postscribe from 'postscribe';

import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    mixins: [baseOrganism],

    data() {
        return {
            tokenValue: '',
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
        }),

        apiKey() {
            return this.settings.google.recaptchaKey || '6LdC3cgUAAAAAF6k6989YAtgr-OLsaOutK14eiRh';
        },

        recaptchaId() {
            return `g-recaptcha-${ this.id }`;
        },
    },

    async mounted() {
        await this.$nextTick();

        postscribe(this.$refs.scriptContainer, `<script src="https://www.google.com/recaptcha/api.js?render=${ this.apiKey }"><\/script>`);
    },
};
</script>
